// import components
import { Box } from '@mui/material';
import { ConfirmationDialog } from 'components/shared';
import ActionCard from 'components/shared/ActionCard';
import ContactDialog, { ProcessedContact } from './ContactDialog';
import { StyledBoxFlexWrapStart } from 'components/shared/Box/Box.styles';
import { StyledLink } from 'components/shared/Link/Link.styles';

// import hooks
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// import types
import { Contact } from './types';

type Props = Contact & {
  onContactSaved: (contact: ProcessedContact) => void;
  onDeleteContact: (id: number) => void;
};

export default function ContactCard(props: Props) {
  const { t } = useTranslation('common');
  const { onContactSaved, onDeleteContact, ...contact } = props;
  const { firstName, lastName, phoneNumber, emailAddress, remark } = contact;
  const [showContactDialog, setShowContactDialog] = useState(false);
  const [showDeleteConfirmationDialog, setShowDeleteConfirmationDialog] =
    useState(false);

  return (
    <>
      <ActionCard
        className="contact"
        sx={{ mb: 2 }}
        title={`${firstName} ${lastName}`}
        onEditClick={() => setShowContactDialog(true)}
        onDeleteClick={() => setShowDeleteConfirmationDialog(true)}
      >
        <StyledBoxFlexWrapStart gap={2}>
          <StyledBoxFlexWrapStart flexDirection="column">
            <StyledLink href={`tel:${phoneNumber}`}>{phoneNumber}</StyledLink>
            <StyledLink
              sx={{
                wordBreak: 'break-word'
              }}
              href={`mailto:${emailAddress}`}
            >
              {emailAddress}
            </StyledLink>
          </StyledBoxFlexWrapStart>
          <Box>{remark || ''}</Box>
        </StyledBoxFlexWrapStart>
      </ActionCard>
      {showContactDialog && (
        <ContactDialog
          contact={contact}
          onSave={onContactSaved}
          onHidden={() => setShowContactDialog(false)}
        />
      )}

      {showDeleteConfirmationDialog && (
        <ConfirmationDialog
          handleAction={(isConfirmed) => {
            setShowDeleteConfirmationDialog(false);
            if (isConfirmed) {
              onDeleteContact(contact.id);
            }
          }}
          cancelBtnText={t('no')}
          confirmBtnText={t('yes')}
          title={t('adminPortal.settings.contacts.deleteContactDialog.title', {
            name: `${firstName} ${lastName}`
          })}
          type="warning"
        >
          <p>{t('adminPortal.settings.contacts.deleteContactDialog.body')}</p>
        </ConfirmationDialog>
      )}
    </>
  );
}
